/** Read complete admin lists without the legacy single-response 200-row limit. */
export async function readAllAdminRows<T extends { id: number }>(
  readPage: (page: number, pageSize: number) => Promise<T[]>
): Promise<T[]>;
export async function readAllAdminRows<T>(
  readPage: (page: number, pageSize: number) => Promise<T[]>, rowId: (row: T) => number
): Promise<T[]>;
export async function readAllAdminRows<T>(
  readPage: (page: number, pageSize: number) => Promise<T[]>, rowId?: (row: T) => number
): Promise<T[]> {
  const pageSize = 200;
  const result: T[] = [];
  const seen = new Set<number>();
  for (let page = 1; ; page++) {
    const rows = await readPage(page, pageSize);
    const newRows: T[] = [];
    for (const row of rows) {
      const id = rowId ? rowId(row) : (row as { id: number }).id;
      if (!Number.isSafeInteger(id) || id < 0) throw new Error('admin_list_invalid_row_id');
      if (!seen.has(id)) { seen.add(id); newRows.push(row); }
    }
    if (rows.length && !newRows.length) throw new Error('admin_list_pagination_unavailable');
    result.push(...newRows);
    if (rows.length < pageSize) return result;
  }
}
